// 仅监控展示排除：验收账号与保留历史归属的「离职人员」账号。
// 不停用账号、不修改订单归属；其他离线/未排班的在职运营仍显示。
const HIDDEN_MONITOR_IDS = new Set(['qa_word_pdf_release', 'xiefenglan'])

export function visibleMonitorTeam(team) {
  return (team || []).filter(a => a.active !== false
    && !HIDDEN_MONITOR_IDS.has(a.id)
    && a.name?.trim() !== '离职人员')
}
